import {Construtor} from './construtor';

export class PontoFisicoParametroGrafico implements Construtor<PontoFisicoParametroGrafico> {
  public idPontoFisicoParametroGrafico: number;
  public idParametroGrafico: number;
  public idPontoFisico: number;
  public alterado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof PontoFisicoParametroGrafico) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      if (!this.modeloCompleto()) {
        return null;
      }

    }

    return this;
  }

  copyObject(tipoPontoFisico: PontoFisicoParametroGrafico): void {
    this.idPontoFisicoParametroGrafico = tipoPontoFisico.idPontoFisicoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idPontoFisico = tipoPontoFisico.idPontoFisico;
  }

  parseFromJson(tipoPontoFisico: any): void {
    this.idPontoFisicoParametroGrafico = tipoPontoFisico.idPontoFisicoParametroGrafico;
    this.idParametroGrafico = tipoPontoFisico.idParametroGrafico;
    this.idPontoFisico = tipoPontoFisico.idPontoFisico;
  }

  modeloCompleto(): boolean {
    return this.idPontoFisico !== undefined;
  }

  getNewInstance(object?: any): PontoFisicoParametroGrafico {
    return new PontoFisicoParametroGrafico(object);
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/ponto-fisico-parametro-grafico.ts